import { render, staticRenderFns } from "./PrizeWidget.vue?vue&type=template&id=0e5f9525&"
import script from "./PrizeWidget.vue?vue&type=script&lang=js&"
export * from "./PrizeWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports